/**
 * Reviews Section — Carousel with autoplay, dots, touch, keyboard
 */

/**
 * Initialize the review carousel.
 */
function initCarousel() {
  var track = document.getElementById('review-track');
  if (!track) return;

  var slides = track.querySelectorAll('.review-card');
  var dots = document.querySelectorAll('.review-carousel__dot');
  var carousel = document.querySelector('.review-carousel');
  var currentIndex = 0;
  var totalSlides = slides.length;
  var autoPlayInterval = null;
  var autoPlayDelay = parseInt(carousel && carousel.getAttribute('data-autoplay-delay'), 10) || 5000;

  function goToSlide(index) {
    if (index < 0) index = totalSlides - 1;
    if (index >= totalSlides) index = 0;
    currentIndex = index;

    track.style.transform = 'translateX(' + (-currentIndex * 100) + '%)';

    dots.forEach(function (dot, i) {
      var isActive = i === currentIndex;
      dot.classList.toggle('review-carousel__dot--active', isActive);
      dot.setAttribute('aria-selected', String(isActive));
    });

    slides.forEach(function (slide, i) {
      slide.setAttribute('aria-hidden', String(i !== currentIndex));
    });
  }

  function startAutoPlay() {
    if (prefersReducedMotion()) return;
    stopAutoPlay();
    autoPlayInterval = setInterval(function () {
      goToSlide(currentIndex + 1);
    }, autoPlayDelay);
  }

  function stopAutoPlay() {
    if (autoPlayInterval) {
      clearInterval(autoPlayInterval);
      autoPlayInterval = null;
    }
  }

  // Dot clicks
  var dotsContainer = document.querySelector('.review-carousel__dots');
  if (dotsContainer) {
    dotsContainer.addEventListener('click', function (e) {
      var dot = e.target.closest('.review-carousel__dot');
      if (!dot) return;
      goToSlide(parseInt(dot.getAttribute('data-slide'), 10));
      stopAutoPlay();
      startAutoPlay();
    });
  }

  // Keyboard arrows
  if (carousel) {
    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goToSlide(currentIndex - 1);
        stopAutoPlay();
        startAutoPlay();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goToSlide(currentIndex + 1);
        stopAutoPlay();
        startAutoPlay();
      }
    });

    // Pause on hover
    carousel.addEventListener('mouseenter', stopAutoPlay);
    carousel.addEventListener('mouseleave', startAutoPlay);
  }

  // Touch/swipe
  var startX = 0;
  var isDragging = false;

  track.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
    isDragging = true;
    stopAutoPlay();
  }, { passive: true });

  track.addEventListener('touchend', function (e) {
    if (!isDragging) return;
    isDragging = false;
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      goToSlide(currentIndex + (diff > 0 ? 1 : -1));
    }
    startAutoPlay();
  }, { passive: true });

  // Initialize
  goToSlide(0);
  startAutoPlay();
}
